import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RealEstateFormValues } from '../types';
import { DropdownProps, OwnerDropdown } from '../../UI';
import { useController, useFormContext } from 'react-hook-form';

interface RealEstateOwnerDropdownProps extends Pick<DropdownProps, 'dropdownMenuClassName' | 'className'> {
  firmID: string;
  clientID: string;
}

export const RealEstateOwnerDropdown: FC<RealEstateOwnerDropdownProps> = (dropdownProps) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<RealEstateFormValues>();
  const {
    field,
    fieldState: { error },
  } = useController<RealEstateFormValues, 'ownerData'>({
    control,
    name: 'ownerData',
    rules: { required: true },
  });

  return (
    <OwnerDropdown
      {...field}
      {...dropdownProps}
      value={field.value?.ownerID}
      status={error ? 'errored' : 'normal'}
      onChange={(data) => field.onChange(data)}
      label={tForm('general-owned-by-dropdown-label')}
      placeholder={tForm('general-required-placeholder')}
    />
  );
};
